import { Box, keyframes, Paper } from '@mui/material';

const marquee = keyframes`
  100% {
    transform: translateX(
      calc((var(--items) * (var(--carousel-item-width) + var(--carousel-item-gap))) * -1)
    );
  }
`;

const CardSlider = ({ cardData }) => {
    const items = cardData.length;

    return (
        <Box
            sx={{
                '--items': items,
                '--carousel-duration': {
                    xs: '40s',
                    sm: '30s',
                },
                '--carousel-width': 'min(80vw, 1200px)',
                '--carousel-item-width': '200px',
                '--carousel-item-height': '250px',
                '--carousel-item-gap': '1rem',
                position: 'relative',
                width: 'var(--carousel-width)',
                height: 'var(--carousel-item-height)',
                overflow: 'hidden',
                maskImage: 'linear-gradient(to right, transparent, black 10% 90%, transparent)',
                '&:hover .carousel-item': {
                    animationPlayState: 'paused',
                },
                mt: 4,
                mb: 2,
            }}
        >
            {cardData.map((card, index) => (
                <Paper
                    key={card.key || index}
                    className="carousel-item"
                    elevation={3}
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 'calc(100% + var(--carousel-item-gap))',
                        width: 'var(--carousel-item-width)',
                        // height: 'var(--carousel-item-height)',
                        height: '90%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        borderRadius: '10px',
                        backgroundColor: '#fff',
                        color: '#314158',
                        overflow: 'hidden',
                        willChange: 'transform',
                        animation: `${marquee} var(--carousel-duration) linear infinite`,
                        animationDelay: `calc((var(--carousel-duration) / var(--items)) * ${index} * -1)`,
                    }}
                >
                    {/* Top image section */}
                    <Box
                        sx={{
                            backgroundImage: `url(${card.img})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '140px',
                            width: '100%',
                            borderTopLeftRadius: '10px',
                            borderTopRightRadius: '10px',
                            position: 'relative',
                        }}
                    >
                        {/* Bookmark icon */}
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 10,
                                right: 10,
                                backgroundColor: 'white',
                                borderRadius: '50%',
                                width: '28px',
                                height: '28px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            🔖
                        </Box>
                    </Box>

                    {/* Content section */}
                    <Box sx={{ p: 1 }}>
                        <Box sx={{ fontWeight: 600, mb: 1 }}>{card.title}</Box>
                        <Box
                            sx={{
                                fontSize: '0.875rem',
                                width: 'fit-content',
                                color:
                                    card.badge === "Premium"
                                        ? "#6a1b9a"
                                        : card.badge === "Upcoming"
                                            ? "#f57c00"
                                            : "red",
                                mb: 1,
                            }}>{card.badge}</Box>
                        <Box
                            sx={{
                                fontSize: '0.875rem',
                                width: 'fit-content',
                                color: 'text.secondary',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                mb: 1,
                            }}>{card.description}</Box>
                        {/* <Box
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 1,
                                backgroundColor: '#e6f8ff',
                                color: '#5f9fff',
                                px: 1.5,
                                py: 0.5,
                                // borderRadius: '10px',
                                fontSize: '0.75rem',
                                fontWeight: 500,
                            }}
                        >
                            Explore
                        </Box> */}
                    </Box>
                </Paper>

            ))}
        </Box>
    );
};

export default CardSlider;
